/*
 * @Descripttion: 
 * @Author: panyufeng
 * @Date: 2025-06-13 10:55:00
 * @LastEditors: panyufeng
 * @LastEditTime: 2025-06-19 11:28:48
 */
import service from '@/utils/request'

// 列表数据查询
export const getList = (params: any) =>
  service.request({
    method: 'post',
    url: '/operation/violationAssistantDevice/page',
    data: params
  })

// 修改
export const update = (params: any) =>
  service.request({
    method: 'post',
    url: '/operation/violationAssistantDevice/edit',
    data: params
  })

// 新增
export const add = (params: any) =>
  service.request({
    method: 'post',
    url: '/operation/violationAssistantDevice/add',
    data: params
  })

// 详情
export const detail = (params: any) =>
  service.request({
    method: 'post',
    url: '/operation/violationAssistantDevice/detail',
    data: params
  })

// 交管会话列表
export const gabOrgSessions = (params: any) =>
  service.request({
    method: 'post',
    url: '/operation/violationAssistantDevice/gabOrgSessions',
    data: params
  })

// 管理员下拉框
export const dropdownOfEnterprise = (params: any) =>
  service.request({
    method: 'post',
    url: 'admin/enterprise/dropdownOfEnterprise',
    data: params
  })

// 交管平台列表
export const platforms = (params: any) =>
  service.request({
    method: 'post',
    url: '/enterpriseViolationSetting/platforms',
    data: params
  })
